export default {
  hero: {
    titlePre: 'Somos',
    titleExpert: 'expertos',
    titleMid: 'en',
    titleHighlight: 'interoperabilidad y automatización',
    titlePost: 'de procesos estratégicos',
    propositionPre: 'Brindamos soluciones de',
    propositionHighlight: 'alto impacto',
    propositionPost: 'en corto tiempo',
    ctaSolutions: 'Conoce nuestras soluciones',
    ctaTalk: 'Habla con nosotros',
  },
  productsSection: {
    titlePre: 'Soluciones',
    titleHighlight: 'GPAX',
    subtitle: 'Plataforma completa para la transformación digital de tu empresa',
    learnMore: 'Dime más',
    saasPre: 'Todos nuestros productos pueden ser suscritos en nuestro ambiente',
    saasHighlight: 'SaaS',
    builder: {
      tagline: 'Innovación sin límites',
      description: 'Innova interoperando los sistemas que ya usas. Conecta, integra y automatiza tus aplicaciones existentes sin necesidad de reemplazarlas.',
      feature1: 'Integración rápida',
      feature2: 'Sin reemplazar sistemas',
      feature3: 'Automatización inteligente',
    },
    transformer: {
      tagline: 'Transformación digital',
      description: 'Transforma y optimiza tus procesos de negocio con tecnología de vanguardia. Moderniza tu infraestructura tecnológica.',
      feature1: 'Modernización',
      feature2: 'Optimización',
      feature3: 'Escalabilidad',
    },
    audit: {
      tagline: 'Control en tiempo real',
      description: 'Gestiona y ejecuta tareas de auditoría en tiempo real. Monitorea, controla y asegura el cumplimiento de tus procesos críticos.',
      feature1: 'Auditoría en tiempo real',
      feature2: 'Trazabilidad completa',
      feature3: 'Cumplimiento normativo',
    },
  },
  credentials: {
    yearsValue: '20+',
    yearsLabel: 'Años innovando',
    yearsSub: 'en Latinoamérica',
    isoValue: 'ISO 27001',
    isoLabel: 'Certificado',
    isoSub: 'Seguridad de la información',
    carbonValue: 'Carbono Neutral',
    carbonLabel: 'Certificado',
    carbonSub: 'Compromiso ambiental',
  },
  commitment: {
    titlePre: 'Nuestro',
    titleHighlight: 'Compromiso',
    textPre: 'Brindamos',
    textHighlight: 'soluciones de alto impacto',
    textPost: 'en corto tiempo',
    speedTitle: 'Rapidez',
    speedDesc: 'Implementación ágil y efectiva',
    impactTitle: 'Impacto',
    impactDesc: 'Resultados medibles y tangibles',
    supportTitle: 'Soporte',
    supportDesc: 'Acompañamiento continuo',
    cta: 'Conoce más sobre nosotros',
  },
  clients: {
    titlePre: 'Confían en',
    titleHighlight: 'Infoware S. A.',
    subtitle: 'Empresas líderes que transforman sus procesos con nuestras soluciones',
    dotLabel: 'Ir a la diapositiva',
  },
  platformBenefits: {
    titlePre: 'Ventajas de nuestra',
    titleHighlight: 'Plataforma',
    subtitle: 'Infraestructura robusta y confiable para tus aplicaciones críticas',
    scalabilityTitle: 'Escalabilidad',
    scalabilityDesc: 'Gestión de diferentes tipos y esquemas de servidores. Crece o adapta al volumen de aplicaciones y/o usuarios, logrando alta escalabilidad.',
    scalabilityFeature1: 'Arquitectura flexible',
    scalabilityFeature2: 'Crecimiento sin límites',
    scalabilityFeature3: 'Optimización de recursos',
    securityTitle: 'Seguridad',
    securityDesc: 'Certificado SSL-EV (certificado verde) de nivel bancario, utilizado por entidades bancarias para que sus clientes puedan realizar transacciones seguras por Internet.',
    securityFeature1: 'Certificado SSL-EV',
    securityFeature2: 'Nivel bancario',
    securityFeature3: 'Transacciones seguras',
    monitoringTitle: 'Monitoreo',
    monitoringDesc: 'Servicio de terceros (Site24x7) proporciona estadísticas en línea en tiempo real, con registros históricos según se requiera.',
    monitoringFeature1: 'Monitoreo 24/7',
    monitoringFeature2: 'Estadísticas en tiempo real',
    monitoringFeature3: 'Registros históricos',
    more: 'Más información sobre nuestra infraestructura',
  },
  cta: {
    titlePre: '¿Listo para',
    titleHighlight: 'transformar',
    titlePost: 'tu empresa?',
    subtitle: 'Contáctanos hoy y descubre cómo nuestras soluciones pueden impulsar tu negocio',
    whatsapp: 'Habla con nosotros por WhatsApp',
    email: 'Envíanos un correo',
    phone: 'Teléfono',
    emailLabel: 'Email',
  },
};